import is from "./filter-set.js";
export default class rs {
  constructor(t, s) {
    (this.xc = t), (this.tf = s), (this.xc = t), (this.tf = s);
  }
  zc(t) {
    if (null == this.xc || null == this.tf) return !1;
    const s = t[0],
      i = t[1];
    return s === this.xc && this.tf.zc(i);
  }
  static fromJson(t) {
    return new rs(
      t ? t.event_name : null,
      t ? is.fromJson(t.property_filters) : null,
    );
  }
  bt() {
    return { e: this.xc, pf: this.tf ? this.tf.bt() : null };
  }
}
